function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function t(t) {
  return t.replace(/(?:[_-])([a-z0-9])/g, function (t, e) {
    return e.toUpperCase();
  });
}

function e(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}

function n(t, e) {
  var n = a(t);
  return Array.from(n.reduce(function (t, n) {
    return function (t, e) {
      var n = t[e];
      return Array.isArray(n) ? n : [];
    }(n, e).forEach(function (e) {
      return t.add(e);
    }), t;
  }, new Set()));
}

function r(t, e) {
  return a(t).reduce(function (t, n) {
    return t.push.apply(t, _toConsumableArray(function (t, e) {
      var n = t[e];
      return n ? Object.keys(n).map(function (t) {
        return [t, n[t]];
      }) : [];
    }(n, e))), t;
  }, []);
}

function a(t) {
  var e = [];

  for (; t;) {
    e.push(t), t = Object.getPrototypeOf(t);
  }

  return e.reverse();
}

function i(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      e = _ref2[0],
      n = _ref2[1];

  return function (e, n) {
    var r = "".concat((i = e, i.replace(/([A-Z])/g, function (t, e) {
      return "-".concat(e.toLowerCase());
    })), "-value"),
        a = function (t) {
      var e = function (t) {
        var e = o(t.type);

        if (e) {
          var _n2 = s(t.default);

          if (e !== _n2) throw new Error("Type \"".concat(e, "\" must match the type of the default value. Given default value: \"").concat(t.default, "\" as \"").concat(_n2, "\""));
          return e;
        }
      }(t),
          n = s(t),
          r = o(t),
          a = e || n || r;

      if (a) return a;
      throw new Error("Unknown value type \"".concat(t, "\""));
    }(n);

    var i;
    return {
      type: a,
      key: r,
      name: t(r),

      get defaultValue() {
        return function (t) {
          var e = o(t);
          if (e) return u[e];
          var n = t.default;
          return void 0 !== n ? n : t;
        }(n);
      },

      get hasCustomDefaultValue() {
        return void 0 !== s(n);
      },

      reader: c[a],
      writer: l[a] || l.default
    };
  }(e, n);
}

function o(t) {
  switch (t) {
    case Array:
      return "array";

    case Boolean:
      return "boolean";

    case Number:
      return "number";

    case Object:
      return "object";

    case String:
      return "string";
  }
}

function s(t) {
  switch (_typeof(t)) {
    case "boolean":
      return "boolean";

    case "number":
      return "number";

    case "string":
      return "string";
  }

  return Array.isArray(t) ? "array" : "[object Object]" === Object.prototype.toString.call(t) ? "object" : void 0;
}

(function () {
  function t(t) {
    function e() {
      return Reflect.construct(t, arguments, this instanceof e ? this.constructor : void 0);
    }

    return e.prototype = Object.create(t.prototype, {
      constructor: {
        value: e
      }
    }), Reflect.setPrototypeOf(e, t), e;
  }

  try {
    (function () {
      var e = t(function () {
        this.a.call(this);
      });
      e.prototype.a = function () {}, new e();
    })();
  } catch (e) {
    return function (t) {
      return /*#__PURE__*/function (_t) {
        _inherits(_class, _t);

        var _super = _createSuper(_class);

        function _class() {
          _classCallCheck(this, _class);

          return _super.apply(this, arguments);
        }

        return _createClass(_class);
      }(t);
    };
  }
})();

var u = {
  get array() {
    return [];
  },

  boolean: !1,
  number: 0,

  get object() {
    return {};
  },

  string: ""
},
    c = {
  array: function array(t) {
    var e = JSON.parse(t);
    if (!Array.isArray(e)) throw new TypeError("Expected array");
    return e;
  },
  boolean: function boolean(t) {
    return !("0" == t || "false" == t);
  },
  number: function number(t) {
    return Number(t);
  },
  object: function object(t) {
    var e = JSON.parse(t);
    if (null === e || "object" != _typeof(e) || Array.isArray(e)) throw new TypeError("Expected object");
    return e;
  },
  string: function string(t) {
    return t;
  }
},
    l = {
  default: function _default(t) {
    return "".concat(t);
  },
  array: d,
  object: d
};

function d(t) {
  return JSON.stringify(t);
}

var h = /*#__PURE__*/function () {
  function h(t) {
    _classCallCheck(this, h);

    this.context = t;
  }

  _createClass(h, [{
    key: "application",
    get: function get() {
      return this.context.application;
    }
  }, {
    key: "scope",
    get: function get() {
      return this.context.scope;
    }
  }, {
    key: "element",
    get: function get() {
      return this.scope.element;
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.scope.identifier;
    }
  }, {
    key: "targets",
    get: function get() {
      return this.scope.targets;
    }
  }, {
    key: "classes",
    get: function get() {
      return this.scope.classes;
    }
  }, {
    key: "data",
    get: function get() {
      return this.scope.data;
    }
  }, {
    key: "initialize",
    value: function initialize() {}
  }, {
    key: "connect",
    value: function connect() {}
  }, {
    key: "disconnect",
    value: function disconnect() {}
  }, {
    key: "dispatch",
    value: function dispatch(t) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref3$target = _ref3.target,
          e = _ref3$target === void 0 ? this.element : _ref3$target,
          _ref3$detail = _ref3.detail,
          n = _ref3$detail === void 0 ? {} : _ref3$detail,
          _ref3$prefix = _ref3.prefix,
          r = _ref3$prefix === void 0 ? this.identifier : _ref3$prefix,
          _ref3$bubbles = _ref3.bubbles,
          a = _ref3$bubbles === void 0 ? !0 : _ref3$bubbles,
          _ref3$cancelable = _ref3.cancelable,
          i = _ref3$cancelable === void 0 ? !0 : _ref3$cancelable;

      var o = new CustomEvent(r ? "".concat(r, ":").concat(t) : t, {
        detail: n,
        bubbles: a,
        cancelable: i
      });
      return e.dispatchEvent(o), o;
    }
  }], [{
    key: "shouldLoad",
    get: function get() {
      return !0;
    }
  }]);

  return h;
}();

function f(t, e) {
  if (e.length < t) throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + e.length + " present");
}

function m(t) {
  f(1, arguments);
  var e = Object.prototype.toString.call(t);
  return t instanceof Date || "object" == _typeof(t) && "[object Date]" === e ? new Date(t.getTime()) : "number" == typeof t || "[object Number]" === e ? new Date(t) : ("string" != typeof t && "[object String]" !== e || "undefined" == typeof console || (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"), console.warn(new Error().stack)), new Date(NaN));
}

function g(t) {
  var e = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return e.setUTCFullYear(t.getFullYear()), t.getTime() - e.getTime();
}

function v(t, e) {
  f(2, arguments);
  var n = m(t),
      r = m(e),
      a = n.getTime() - r.getTime();
  return a < 0 ? -1 : a > 0 ? 1 : a;
}

function b(t, e) {
  f(2, arguments);
  var n = m(t),
      r = m(e),
      a = n.getFullYear() - r.getFullYear(),
      i = n.getMonth() - r.getMonth();
  return 12 * a + i;
}

function y(t, e) {
  return f(2, arguments), m(t).getTime() - m(e).getTime();
}

h.blessings = [function (t) {
  return n(t, "classes").reduce(function (t, n) {
    var _Object$assign;

    return Object.assign(t, (_Object$assign = {}, _defineProperty(_Object$assign, "".concat(r = n, "Class"), {
      get: function get() {
        var t = this.classes;
        if (t.has(r)) return t.get(r);
        {
          var _e2 = t.getAttributeName(r);

          throw new Error("Missing attribute \"".concat(_e2, "\""));
        }
      }
    }), _defineProperty(_Object$assign, "".concat(r, "Classes"), {
      get: function get() {
        return this.classes.getAll(r);
      }
    }), _defineProperty(_Object$assign, "has".concat(e(r), "Class"), {
      get: function get() {
        return this.classes.has(r);
      }
    }), _Object$assign));
    var r;
  }, {});
}, function (t) {
  return n(t, "targets").reduce(function (t, n) {
    var _Object$assign2;

    return Object.assign(t, (_Object$assign2 = {}, _defineProperty(_Object$assign2, "".concat(r = n, "Target"), {
      get: function get() {
        var t = this.targets.find(r);
        if (t) return t;
        throw new Error("Missing target element \"".concat(r, "\" for \"").concat(this.identifier, "\" controller"));
      }
    }), _defineProperty(_Object$assign2, "".concat(r, "Targets"), {
      get: function get() {
        return this.targets.findAll(r);
      }
    }), _defineProperty(_Object$assign2, "has".concat(e(r), "Target"), {
      get: function get() {
        return this.targets.has(r);
      }
    }), _Object$assign2));
    var r;
  }, {});
}, function (t) {
  var n = r(t, "values"),
      a = {
    valueDescriptorMap: {
      get: function get() {
        var _this = this;

        return n.reduce(function (t, e) {
          var n = i(e),
              r = _this.data.getAttributeNameForKey(n.key);

          return Object.assign(t, _defineProperty({}, r, n));
        }, {});
      }
    }
  };
  return n.reduce(function (t, n) {
    return Object.assign(t, function (t) {
      var _ref4;

      var n = i(t),
          r = n.key,
          a = n.name,
          o = n.reader,
          s = n.writer;
      return _ref4 = {}, _defineProperty(_ref4, a, {
        get: function get() {
          var t = this.data.get(r);
          return null !== t ? o(t) : n.defaultValue;
        },
        set: function set(t) {
          void 0 === t ? this.data.delete(r) : this.data.set(r, s(t));
        }
      }), _defineProperty(_ref4, "has".concat(e(a)), {
        get: function get() {
          return this.data.has(r) || n.hasCustomDefaultValue;
        }
      }), _ref4;
    }(n));
  }, a);
}], h.targets = [], h.values = {};
var p = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function trunc(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
  }
};

function w(t) {
  return t ? p[t] : p.trunc;
}

function M(t) {
  f(1, arguments);
  var e = m(t);
  return e.setHours(23, 59, 59, 999), e;
}

function S(t) {
  f(1, arguments);
  var e = m(t),
      n = e.getMonth();
  return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(23, 59, 59, 999), e;
}

function D(t) {
  f(1, arguments);
  var e = m(t);
  return M(e).getTime() === S(e).getTime();
}

function T(t, e) {
  f(2, arguments);
  var n,
      r = m(t),
      a = m(e),
      i = v(r, a),
      o = Math.abs(b(r, a));
  if (o < 1) n = 0;else {
    1 === r.getMonth() && r.getDate() > 27 && r.setDate(30), r.setMonth(r.getMonth() - i * o);
    var s = v(r, a) === -i;
    D(m(t)) && 1 === o && 1 === v(t, a) && (s = !1), n = i * (o - Number(s));
  }
  return 0 === n ? 0 : n;
}

function j(t, e, n) {
  f(2, arguments);
  var r = y(t, e) / 1e3;
  return w(null == n ? void 0 : n.roundingMethod)(r);
}

var W = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};

function P(t) {
  return function () {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        n = e.width ? String(e.width) : t.defaultWidth,
        r = t.formats[n] || t.formats[t.defaultWidth];
    return r;
  };
}

var A = {
  date: P({
    formats: {
      full: "EEEE, MMMM do, y",
      long: "MMMM do, y",
      medium: "MMM d, y",
      short: "MM/dd/yyyy"
    },
    defaultWidth: "full"
  }),
  time: P({
    formats: {
      full: "h:mm:ss a zzzz",
      long: "h:mm:ss a z",
      medium: "h:mm:ss a",
      short: "h:mm a"
    },
    defaultWidth: "full"
  }),
  dateTime: P({
    formats: {
      full: "{{date}} 'at' {{time}}",
      long: "{{date}} 'at' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    },
    defaultWidth: "full"
  })
},
    x = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};

function k(t) {
  return function (e, n) {
    var r,
        a = n || {};

    if ("formatting" === (a.context ? String(a.context) : "standalone") && t.formattingValues) {
      var i = t.defaultFormattingWidth || t.defaultWidth,
          o = a.width ? String(a.width) : i;
      r = t.formattingValues[o] || t.formattingValues[i];
    } else {
      var s = t.defaultWidth,
          u = a.width ? String(a.width) : t.defaultWidth;
      r = t.values[u] || t.values[s];
    }

    return r[t.argumentCallback ? t.argumentCallback(e) : e];
  };
}

function C(t) {
  return function (e) {
    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = n.width,
        a = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth],
        i = e.match(a);
    if (!i) return null;
    var o,
        s = i[0],
        u = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth],
        c = Array.isArray(u) ? N(u, function (t) {
      return t.test(s);
    }) : O(u, function (t) {
      return t.test(s);
    });
    o = t.valueCallback ? t.valueCallback(c) : c, o = n.valueCallback ? n.valueCallback(o) : o;
    var l = e.slice(s.length);
    return {
      value: o,
      rest: l
    };
  };
}

function O(t, e) {
  for (var n in t) {
    if (t.hasOwnProperty(n) && e(t[n])) return n;
  }
}

function N(t, e) {
  for (var n = 0; n < t.length; n++) {
    if (e(t[n])) return n;
  }
}

var E,
    $ = {
  code: "en-US",
  formatDistance: function formatDistance(t, e, n) {
    var r,
        a = W[t];
    return r = "string" == typeof a ? a : 1 === e ? a.one : a.other.replace("{{count}}", e.toString()), null != n && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
  },
  formatLong: A,
  formatRelative: function formatRelative(t, e, n, r) {
    return x[t];
  },
  localize: {
    ordinalNumber: function ordinalNumber(t, e) {
      var n = Number(t),
          r = n % 100;
      if (r > 20 || r < 10) switch (r % 10) {
        case 1:
          return n + "st";

        case 2:
          return n + "nd";

        case 3:
          return n + "rd";
      }
      return n + "th";
    },
    era: k({
      values: {
        narrow: ["B", "A"],
        abbreviated: ["BC", "AD"],
        wide: ["Before Christ", "Anno Domini"]
      },
      defaultWidth: "wide"
    }),
    quarter: k({
      values: {
        narrow: ["1", "2", "3", "4"],
        abbreviated: ["Q1", "Q2", "Q3", "Q4"],
        wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
      },
      defaultWidth: "wide",
      argumentCallback: function argumentCallback(t) {
        return t - 1;
      }
    }),
    month: k({
      values: {
        narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
        abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
      },
      defaultWidth: "wide"
    }),
    day: k({
      values: {
        narrow: ["S", "M", "T", "W", "T", "F", "S"],
        short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
      },
      defaultWidth: "wide"
    }),
    dayPeriod: k({
      values: {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "mi",
          noon: "n",
          morning: "morning",
          afternoon: "afternoon",
          evening: "evening",
          night: "night"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "midnight",
          noon: "noon",
          morning: "morning",
          afternoon: "afternoon",
          evening: "evening",
          night: "night"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "midnight",
          noon: "noon",
          morning: "morning",
          afternoon: "afternoon",
          evening: "evening",
          night: "night"
        }
      },
      defaultWidth: "wide",
      formattingValues: {
        narrow: {
          am: "a",
          pm: "p",
          midnight: "mi",
          noon: "n",
          morning: "in the morning",
          afternoon: "in the afternoon",
          evening: "in the evening",
          night: "at night"
        },
        abbreviated: {
          am: "AM",
          pm: "PM",
          midnight: "midnight",
          noon: "noon",
          morning: "in the morning",
          afternoon: "in the afternoon",
          evening: "in the evening",
          night: "at night"
        },
        wide: {
          am: "a.m.",
          pm: "p.m.",
          midnight: "midnight",
          noon: "noon",
          morning: "in the morning",
          afternoon: "in the afternoon",
          evening: "in the evening",
          night: "at night"
        }
      },
      defaultFormattingWidth: "wide"
    })
  },
  match: {
    ordinalNumber: (E = {
      matchPattern: /^(\d+)(th|st|nd|rd)?/i,
      parsePattern: /\d+/i,
      valueCallback: function valueCallback(t) {
        return parseInt(t, 10);
      }
    }, function (t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = t.match(E.matchPattern);
      if (!n) return null;
      var r = n[0],
          a = t.match(E.parsePattern);
      if (!a) return null;
      var i = E.valueCallback ? E.valueCallback(a[0]) : a[0];
      i = e.valueCallback ? e.valueCallback(i) : i;
      var o = t.slice(r.length);
      return {
        value: i,
        rest: o
      };
    }),
    era: C({
      matchPatterns: {
        narrow: /^(b|a)/i,
        abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
        wide: /^(before christ|before common era|anno domini|common era)/i
      },
      defaultMatchWidth: "wide",
      parsePatterns: {
        any: [/^b/i, /^(a|c)/i]
      },
      defaultParseWidth: "any"
    }),
    quarter: C({
      matchPatterns: {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](th|st|nd|rd)? quarter/i
      },
      defaultMatchWidth: "wide",
      parsePatterns: {
        any: [/1/i, /2/i, /3/i, /4/i]
      },
      defaultParseWidth: "any",
      valueCallback: function valueCallback(t) {
        return t + 1;
      }
    }),
    month: C({
      matchPatterns: {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
        wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
      },
      defaultMatchWidth: "wide",
      parsePatterns: {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      },
      defaultParseWidth: "any"
    }),
    day: C({
      matchPatterns: {
        narrow: /^[smtwf]/i,
        short: /^(su|mo|tu|we|th|fr|sa)/i,
        abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
        wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
      },
      defaultMatchWidth: "wide",
      parsePatterns: {
        narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
        any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
      },
      defaultParseWidth: "any"
    }),
    dayPeriod: C({
      matchPatterns: {
        narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
        any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
      },
      defaultMatchWidth: "any",
      parsePatterns: {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mi/i,
          noon: /^no/i,
          morning: /morning/i,
          afternoon: /afternoon/i,
          evening: /evening/i,
          night: /night/i
        }
      },
      defaultParseWidth: "any"
    })
  },
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};

function X(t) {
  return function (t, e) {
    if (null == t) throw new TypeError("assign requires that input parameter not be null or undefined");

    for (var n in e = e || {}) {
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    }

    return t;
  }({}, t);
}

function V(t, e) {
  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
  f(2, arguments);
  var r = n.locale || $;
  if (!r.formatDistance) throw new RangeError("locale must contain formatDistance property");
  var a = v(t, e);
  if (isNaN(a)) throw new RangeError("Invalid time value");
  var i,
      o,
      s = X(n);
  s.addSuffix = Boolean(n.addSuffix), s.comparison = a, a > 0 ? (i = m(e), o = m(t)) : (i = m(t), o = m(e));
  var u,
      c = j(o, i),
      l = (g(o) - g(i)) / 1e3,
      d = Math.round((c - l) / 60);
  if (d < 2) return n.includeSeconds ? c < 5 ? r.formatDistance("lessThanXSeconds", 5, s) : c < 10 ? r.formatDistance("lessThanXSeconds", 10, s) : c < 20 ? r.formatDistance("lessThanXSeconds", 20, s) : c < 40 ? r.formatDistance("halfAMinute", null, s) : c < 60 ? r.formatDistance("lessThanXMinutes", 1, s) : r.formatDistance("xMinutes", 1, s) : 0 === d ? r.formatDistance("lessThanXMinutes", 1, s) : r.formatDistance("xMinutes", d, s);
  if (d < 45) return r.formatDistance("xMinutes", d, s);
  if (d < 90) return r.formatDistance("aboutXHours", 1, s);

  if (d < 1440) {
    var h = Math.round(d / 60);
    return r.formatDistance("aboutXHours", h, s);
  }

  if (d < 2520) return r.formatDistance("xDays", 1, s);

  if (d < 43200) {
    var b = Math.round(d / 1440);
    return r.formatDistance("xDays", b, s);
  }

  if (d < 86400) return u = Math.round(d / 43200), r.formatDistance("aboutXMonths", u, s);

  if ((u = T(o, i)) < 12) {
    var y = Math.round(d / 43200);
    return r.formatDistance("xMonths", y, s);
  }

  var p = u % 12,
      w = Math.floor(u / 12);
  return p < 3 ? r.formatDistance("aboutXYears", w, s) : p < 9 ? r.formatDistance("overXYears", w, s) : r.formatDistance("almostXYears", w + 1, s);
}

var F = /*#__PURE__*/function (_h) {
  _inherits(F, _h);

  var _super2 = _createSuper(F);

  function F() {
    _classCallCheck(this, F);

    return _super2.apply(this, arguments);
  }

  _createClass(F, [{
    key: "initialize",
    value: function initialize() {
      this.isValid = !0;
    }
  }, {
    key: "connect",
    value: function connect() {
      this.load(), this.hasRefreshIntervalValue && this.isValid && this.startRefreshing();
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      this.stopRefreshing();
    }
  }, {
    key: "load",
    value: function load() {
      var t = this.datetimeValue,
          e = Date.parse(t),
          n = {
        includeSeconds: this.hasIncludeSecondsValue,
        addSuffix: this.hasAddSuffixValue,
        locale: this.locale
      };
      Number.isNaN(e) && (this.isValid = !1, console.error("[stimulus-timeago] Value given in 'data-timeago-datetime' is not a valid date (".concat(t, "). Please provide a ISO 8601 compatible datetime string. Displaying given value instead."))), this.element.dateTime = t, this.element.innerHTML = this.isValid ? function (t, e) {
        return f(1, arguments), V(t, Date.now(), e);
      }(e, n) : t;
    }
  }, {
    key: "startRefreshing",
    value: function startRefreshing() {
      var _this2 = this;

      this.refreshTimer = setInterval(function () {
        _this2.load();
      }, this.refreshIntervalValue);
    }
  }, {
    key: "stopRefreshing",
    value: function stopRefreshing() {
      this.refreshTimer && clearInterval(this.refreshTimer);
    }
  }]);

  return F;
}(h);

F.values = {
  datetime: String,
  refreshInterval: Number,
  includeSeconds: Boolean,
  addSuffix: Boolean
};
export default F;